const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const isValidIsoDate = (value: string): boolean => {
  const match = ISO_DATE_PATTERN.exec(value);

  if (!match) {
    return false;
  }

  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));

  return (
    date.getUTCFullYear() === Number(year) &&
    date.getUTCMonth() === Number(month) - 1 &&
    date.getUTCDate() === Number(day)
  );
};

export const getReportPeriodError = (dataInicio: string, dataFim: string): string | null => {
  if (!dataInicio || !dataFim) {
    return "Informe a data inicial e a data final.";
  }

  if (!isValidIsoDate(dataInicio) || !isValidIsoDate(dataFim)) {
    return "Informe datas válidas.";
  }

  if (dataFim < dataInicio) {
    return "A data final não pode ser menor que a data inicial.";
  }

  return null;
};
